import React from "react";
import { Navigate } from "react-router-dom";
import { usePortalAuth } from "@/contexts/PortalAuthContext";

export default function PortalProtectedRoute({ children }) {
  const { customer, loading } = usePortalAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-sm text-[#64748B]">Yükleniyor…</div>;
  if (!customer) return <Navigate to="/portal/login" replace />;
  return children;
}
